// extracted by mini-css-extract-plugin
export var attribution = "_1g-4";
export var authorName = "_1g-5";
export var option = "_1g-g";
export var optionCard = "_1g-v";
export var optionContent = "_1g-w";
export var optionGrid = "_1g-12";
export var optionIcon = "_1g-y";
export var optionIconBox = "_1g-x";
export var optionLabel = "_1g-z";
export var optionList = "_1g-f";
export var optionPill = "_1g-13";
export var optionPillBadge = "_1g-16";
export var optionPillIcon = "_1g-14";
export var optionPillLabel = "_1g-15";
export var optionRadio = "_1g-10";
export var optionRadioInner = "_1g-11";
export var optionReveal = "_1g-i";
export var optionRevealDelay0 = "_1g-j";
export var optionRevealDelay1 = "_1g-k";
export var optionRevealDelay10 = "_1g-t";
export var optionRevealDelay11 = "_1g-u";
export var optionRevealDelay2 = "_1g-l";
export var optionRevealDelay3 = "_1g-m";
export var optionRevealDelay4 = "_1g-n";
export var optionRevealDelay5 = "_1g-o";
export var optionRevealDelay6 = "_1g-p";
export var optionRevealDelay7 = "_1g-q";
export var optionRevealDelay8 = "_1g-r";
export var optionRevealDelay9 = "_1g-s";
export var optionSelected = "_1g-h";
export var questionsBlock = "_1g-18";
export var quote = "_1g-3";
export var spacer = "_1g-b";
export var stepCenteredContent = "_1g-9";
export var stepInner = "_1g-6";
export var stepInnerFullWidth = "_1g-7";
export var stepInnerLockScroll = "_1g-8";
export var stepTransitionFrame = "_1g-a";
export var subtitle = "_1g-e";
export var testimonial = "_1g-2";
export var title = "_1g-c";
export var titleWithAccessory = "_1g-d";
export var trustedBy = "_1g-0";
export var trustedByLabel = "_1g-1";
export var welcomeBlock = "_1g-17";